/* Boheia: Represent-style product page */
(function () {
  /* ---------- gallery ---------- */
  if (!customElements.get('rp-gallery')) {
    customElements.define('rp-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.track.children);
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.count = this.querySelector('[data-current]');
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index() - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.t);
          this.t = setTimeout(() => this.update(), 60);
        }, { passive: true });
        const zoomBtn = this.querySelector('[data-zoom]');
        const dlg = this.querySelector('dialog');
        if (zoomBtn && dlg) {
          zoomBtn.addEventListener('click', () => {
            dlg.showModal();
            const target = dlg.querySelectorAll('img')[this.index()];
            if (target) target.scrollIntoView({ block: 'start' });
          });
          dlg.querySelector('[data-close]').addEventListener('click', () => dlg.close());
        }
        this.update();
      }
      index() {
        const w = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / w);
      }
      go(i) {
        const max = this.slides.length - 1;
        i = Math.max(0, Math.min(max, i));
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      }
      goToMedia(id) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
        if (i >= 0) this.go(i);
      }
      update() {
        const i = this.index();
        if (this.count) this.count.textContent = i + 1;
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.slides.length - 1;
      }
    });
  }

  /* ---------- variant picker ---------- */
  function initMain(root) {
    if (root.dataset.rpReady) return;
    root.dataset.rpReady = '1';
    const dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const groups = Array.from(root.querySelectorAll('[data-option-index]'));
    const input = root.querySelector('product-form input[name="id"]');
    const atc = root.querySelector('.rp-atc');
    const label = atc && atc.querySelector('[data-atc-label]');
    const priceEl = root.querySelector('[data-price]');
    const gallery = root.querySelector('rp-gallery');
    const texts = JSON.parse(root.querySelector('[data-texts]').textContent);
    const selected = groups.map((g) => {
      const a = g.querySelector('.is-active');
      return a ? a.dataset.value : null;
    });

    function match() {
      if (selected.some((v) => v === null)) return null;
      return variants.find((v) => v.options.every((o, i) => o === selected[i])) || null;
    }
    function refreshAvailability() {
      groups.forEach((g, gi) => {
        g.querySelectorAll('[data-value]').forEach((btn) => {
          const ok = variants.some((v) => v.available && v.options[gi] === btn.dataset.value &&
            v.options.every((o, i) => i === gi || selected[i] === null || o === selected[i]));
          btn.classList.toggle('is-soldout', !ok);
        });
      });
    }
    function render(fromUser) {
      const v = match();
      if (v) {
        if (input) input.value = v.id;
        if (priceEl) priceEl.innerHTML = v.compare ? '<s>' + v.compare + '</s><span class="is-sale">' + v.price + '</span>' : v.price;
        if (label) label.textContent = v.available ? texts.add : texts.soldout;
        if (atc) atc.toggleAttribute('disabled', !v.available);
        if (fromUser && root.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        if (input) input.value = '';
        if (label) label.textContent = texts.add;
        if (atc) atc.removeAttribute('disabled');
      }
      refreshAvailability();
      return v;
    }

    groups.forEach((g, gi) => {
      g.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-value]');
        if (!btn) return;
        e.preventDefault();
        g.querySelectorAll('[data-value]').forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        selected[gi] = btn.dataset.value;
        g.classList.remove('is-missing');
        const name = g.querySelector('[data-selected-name]');
        if (name) name.textContent = btn.dataset.value;
        const v = render(true);
        if (gallery && btn.dataset.media) gallery.goToMedia(btn.dataset.media);
        else if (gallery && v && v.media && g.dataset.colour === 'true') gallery.goToMedia(v.media);
        const err = root.querySelector('.rp-error');
        if (err) err.hidden = true;
      });
    });

    if (atc) {
      atc.addEventListener('click', (e) => {
        if (match()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        groups.forEach((g, i) => { if (selected[i] === null) g.classList.add('is-missing'); });
        const err = root.querySelector('.rp-error');
        if (err) {
          err.hidden = false;
          const msg = err.querySelector('.product-form__error-message');
          if (msg) msg.textContent = texts.select;
        }
      }, true);
    }

    const fit = root.querySelector('[data-fit]');
    if (fit) fit.addEventListener('click', () => {
      const b = root.querySelector('.bh-sizechart__btn');
      if (b) b.click();
    });

    root.querySelectorAll('[data-usp-pop]').forEach((b) => {
      b.addEventListener('click', () => {
        const d = document.getElementById(b.dataset.uspPop);
        if (d) d.showModal();
      });
    });
    root.querySelectorAll('.rp-usp-pop').forEach((d) => {
      d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('[data-close]')) d.close(); });
    });

    const tabs = Array.from(root.querySelectorAll('.rp-tab'));
    tabs.forEach((t) => {
      t.addEventListener('click', () => {
        const open = t.getAttribute('aria-expanded') === 'true';
        tabs.forEach((o) => {
          o.setAttribute('aria-expanded', 'false');
          const p = document.getElementById(o.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        });
        if (!open) {
          t.setAttribute('aria-expanded', 'true');
          const p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = false;
        }
      });
    });

    render(false);
  }

  /* ---------- quick add on cards ---------- */
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('.rp-card__plus');
    if (plus) {
      e.preventDefault();
      const card = plus.closest('.rp-card');
      const open = card.classList.toggle('is-quick');
      plus.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.rp-card__quick form');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter;
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    const drawer = document.querySelector('cart-drawer');
    const body = { id: Number(btn.value), quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) { alert(data.description || data.message || 'Error'); return; }
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1200);
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rp-quick-add', productVariantId: body.id, cartData: data });
      } else {
        window.location.href = cartUrl;
      }
    } catch (err) {
      console.error(err);
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- recommendations + tabs ---------- */
  async function initRecs(sec) {
    if (sec.dataset.rpReady) return;
    sec.dataset.rpReady = '1';
    const tabs = Array.from(sec.querySelectorAll('.rp-rtab'));
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((o) => {
        const on = o === t;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        const p = document.getElementById(o.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }));
    const slot = sec.querySelector('[data-recs-url]');
    if (!slot) return;
    try {
      const html = await (await fetch(slot.dataset.recsUrl)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const got = doc.querySelector('[data-recs-result]');
      if (got && got.innerHTML.trim()) slot.innerHTML = got.innerHTML;
      else if (sec.dataset.hideEmpty === 'true' && tabs.length <= 1) sec.hidden = true;
      else slot.innerHTML = '';
    } catch (err) { console.error(err); }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rp-main]').forEach(initMain);
    (scope || document).querySelectorAll('[data-rp-recs]').forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
